import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import {CloseButton} from './CloseButton';
import style from './style.module.scss';

ReactModal.setAppElement('#root');

/**
 * Modal:
 *  - Modal window component based on react-modal package
 */
export function Modal(props) {
  const renderCloseButton = () =>
    props.closeButton ? (
      <CloseButton className={props.className} close={props.close} />
    ) : null;

  const contentClass = `${style.modal_content} ${props.className} ${props.className}_content`;

  const overlayClass = `${style.modal_overlay} ${props.className}_overlay`;

  return (
    <ReactModal
      className={contentClass}
      overlayClassName={overlayClass}
      isOpen={props.isOpen}
      onRequestClose={props.close}
      shouldCloseOnOverlayClick={props.closeOnOverlayClick}>
      {renderCloseButton()}
      {props.children}
    </ReactModal>
  );
}

Modal.propTypes = {
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Fuction to close modal
   */
  close: PropTypes.func,
  /**
   * Component/Components to display on Modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Close Modal window when cliked on overlay
   */
  closeOnOverlayClick: PropTypes.bool,
  /**
   * ClassName for overlay and content tags
   */
  className: PropTypes.string,
  /**
   * Show closeButton or not
   */
  closeButton: PropTypes.bool,
};

Modal.defaultProps = {
  isOpen: false,
  closeOnOverlayClick: false,
  className: '',
  closeButton: false,
};
